/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCollaborator_inviteCollaborator_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null, readonly createAsAdmin: boolean | null };

export type UpdateCollaborator_Mutation = { readonly __typename: 'Mutation', readonly inviteCollaborator: ReadonlyArray<UpdateCollaborator_inviteCollaborator_CreditApplicationPerson> | null };


export type UpdateCollaboratorVariables = _Types.Exact<{
  salesforceCreditId: _Types.Scalars['ID']['input'];
  collaborator: _Types.PersonInput;
}>;


export type UpdateCollaborator = UpdateCollaborator_Mutation;


export const UpdateCollaboratorDocument = gql`
    mutation UpdateCollaborator($salesforceCreditId: ID!, $collaborator: PersonInput!) {
  inviteCollaborator(
    salesforceCreditId: $salesforceCreditId
    collaborator: $collaborator
  ) {
    id
    firstName
    lastName
    email
    createAsAdmin
  }
}
    `;
export type UpdateCollaboratorMutationFn = Apollo.MutationFunction<UpdateCollaborator, UpdateCollaboratorVariables>;

/**
 * __useUpdateCollaborator__
 *
 * To run a mutation, you first call `useUpdateCollaborator` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollaborator` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollaborator, { data, loading, error }] = useUpdateCollaborator({
 *   variables: {
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *      collaborator: // value for 'collaborator'
 *   },
 * });
 */
export function useUpdateCollaborator(baseOptions?: Apollo.MutationHookOptions<UpdateCollaborator, UpdateCollaboratorVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollaborator, UpdateCollaboratorVariables>(UpdateCollaboratorDocument, options);
      }
export type UpdateCollaboratorHookResult = ReturnType<typeof useUpdateCollaborator>;
export type UpdateCollaboratorMutationResult = Apollo.MutationResult<UpdateCollaborator>;
export type UpdateCollaboratorMutationOptions = Apollo.BaseMutationOptions<UpdateCollaborator, UpdateCollaboratorVariables>;